import { createTheme } from "@mui/material/styles";
import { palette } from "./palette";
import { typography } from "./typography";
import { shadows } from "./shadows";
import { componentsOverrides } from "./overrides";

// Two-step createTheme so component overrides can reference the resolved theme
// (spacing, palette, breakpoints).
let theme = createTheme({
  palette,
  typography,
  shadows,
  shape: { borderRadius: 8 },
});

theme = createTheme(theme, {
  components: componentsOverrides(theme),
});

export default theme;
